import {
  CalendarDate,
  Time,
  today,
  getLocalTimeZone,
} from '@internationalized/date';
import {
  enumVariableSortOption,
  VariableSortOption,
} from '@rematter/frontend-lib-api-client';
import { atom } from 'jotai';

import { variableDeleteAtom } from '../_graphql/mutationVariableCrud';
import { variablesListQueryAtom } from '../_graphql/queryVariablesList';
import { PendingVariableChange, VariableRecord } from '../types/pricing';

import { atomFromQueryString } from '~/shared/state';

export const $searchTerm = atomFromQueryString.string('vq');
export const $limit = atomFromQueryString.number('vlimit', 50);
export const $offset = atomFromQueryString.number('voffset', 0);

export const $isCreateDialogOpen = atom<boolean>(false);
export const $isEditDialogOpen = atom<boolean>(false);
export const $selectedVariable = atom<VariableRecord | null>(null);
export const $currentSorting = atom<VariableSortOption[]>([
  enumVariableSortOption.NameAsc,
]);

export const $remoteVariables = variablesListQueryAtom((get) => {
  const searchTerm = get($searchTerm);
  const limit = get($limit);
  const offset = get($offset);
  const sorting = get($currentSorting);

  return {
    variables: {
      searchTerm: searchTerm || undefined,
      limit,
      offset,
      sorting,
    },
  };
});

export const $remoteAllVariables = variablesListQueryAtom(() => ({
  variables: {
    limit: 1000,
    offset: 0,
    sorting: [enumVariableSortOption.NameAsc],
  },
}));

export const $allVariablesForAutocomplete = atom<VariableRecord[]>((get) => {
  const data = get($remoteAllVariables);
  return data?.data?.variables ?? [];
});

export const $deleteVariable = variableDeleteAtom({
  onSuccess: (get) => {
    get($remoteVariables).refetch?.();
  },
});

export const $pendingChanges = atom<Map<string, PendingVariableChange>>(
  new Map(),
);

export const $pendingCount = atom((get) => get($pendingChanges).size);

export const $effectiveDate = atom<CalendarDate>(today(getLocalTimeZone()));

export const $effectiveTime = atom<Time | null>(null);

export const $isHistoryDialogOpen = atom<boolean>(false);
export const $selectedHistoryVariableId = atom<string | null>(null);
export const $selectedHistoryVariableName = atom<string | null>(null);
